/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import logo from "../../assets/images/logo-8icragee.png";
import { useEffect } from "react";

const Navbar = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [show, setShow] = useState(false);
  const [isSubSubMenuOpen, setSubSubMenuOpen] = useState(false);
  const [isSubSubMenuOpen2, setSubSubMenuOpen2] = useState(false);
  const handleShow = () => {
    setShow(!show);
  };
  const [navbarPosition, setNavbarPosition] = useState("relative");

  const handleScroll = () => {
    if (window.scrollY > 500) {
      setNavbarPosition("fixed");
    } else {
      setNavbarPosition("relative");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMouseEnter = () => {
    setDropdownVisible(true);
  };

  const handleMouseLeave = () => {
    setDropdownVisible(false);
  };
  const [isDropdownVisible2, setDropdownVisible2] = useState(false);

  const handleMouseEnter2 = () => {
    setDropdownVisible2(true);
  };

  const handleMouseLeave2 = () => {
    setDropdownVisible2(false);
  };

  const [isDropdownVisible3, setDropdownVisible3] = useState(false);
  const [isDropdownVisible4, setDropdownVisible4] = useState(false);
  const [isDropdownVisible5, setDropdownVisible5] = useState(false);
  const [isDropdownVisible9, setDropdownVisible9] = useState(false);

  const handleMouseEnter3 = () => {
    setDropdownVisible3(true);
  };

  const handleMouseLeave3 = () => {
    setDropdownVisible3(false);
  };
  const handleMouseEnter4 = () => {
    setSubSubMenuOpen(true);
    setSubSubMenuOpen2(false);
  };
  const handleMouseLeave4 = () => {
    setSubSubMenuOpen(false);
  };
  const handleMouseEnter8 = () => {
    setSubSubMenuOpen(true);
    setSubSubMenuOpen2(false);
  };
  const handleMouseEnter5 = () => {
    setDropdownVisible4(true);
  };
  const handleMouseLeave5 = () => {
    setDropdownVisible4(false);
  };
  const handleMouseEnter6 = () => {
    setDropdownVisible5(true);
  };
  const handleMouseLeave6 = () => {
    setDropdownVisible5(false);
  };
  const handleMouseEnter7 = () => {
    setSubSubMenuOpen2(true);
    setSubSubMenuOpen(false);
  };
  const handleMouseLeave7 = () => {
    setSubSubMenuOpen2(false);
  };
  const handleMouseLeave8 = () => {
    setSubSubMenuOpen(false);
  };
  const handleMouseEnter9 = () => {
    setDropdownVisible9(true);
  };
  const handleMouseLeave9 = () => {
    setDropdownVisible9(false);
  };
  const [isAbstractSubmissionOpen, setIsAbstractSubmissionOpen] =
    useState(false);
  const [isSpeakersOpen, setIsSpeakersOpen] = useState(false);
  const [isFullLengthSubmissionOpen, setIsFullLengthSubmissionOpen] =
    useState(false);
  const [isSubmissionsOpen, setIsSubmissionsOpen] = useState(false);
  const [isProgrammeOpen, setIsProgrammeOpen] = useState(false);
  const [isCommitteeOpen, setIsCommitteeOpen] = useState(false);
  const [isAccomodationOpen, setIsAccomodationOpen] = useState(false);
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);

  const handleSpeakersClick = () => {
    setIsSpeakersOpen(!isSpeakersOpen);
  };

  const handleSubmissionsClick = () => {
    setIsSubmissionsOpen(!isSubmissionsOpen);
  };
  const handleAbstractSubmissionClick = () => {
    setIsAbstractSubmissionOpen(!isAbstractSubmissionOpen);
  };
  const handleFullLengthSubmissionClick = () => {
    setIsFullLengthSubmissionOpen(!isFullLengthSubmissionOpen);
  };
  const handleProgrammeClick = () => {
    setIsProgrammeOpen(!isProgrammeOpen);
  };
  const handleCommitteeClick = () => {
    setIsCommitteeOpen(!isCommitteeOpen);
  };
  const handleAccoClick = () => {
    setIsAccomodationOpen(!isAccomodationOpen);
  };
  const handleRegistrationClick = () => {
    setIsRegistrationOpen(!isRegistrationOpen);
  };
  return (
    <div>
      <div className={`app min-w-screen ${navbarPosition} z-[100]`}>
        <nav className="md:flex hidden bg-cyan-600 flex-row justify-between py-4 items-center px-12 text-[20px] text-white">
          {/* <div>
            <img src={logo} className="h-10 mx-8" />
          </div>
          <div className="lg:flex hidden flex-row justify-end px-12  text-[20px] text-white gap-20"> */}
          <div
            className="menu"
            onMouseEnter={handleMouseEnter6}
            onMouseLeave={handleMouseLeave6}
          >
            <a href="/8icragee/">Home</a>
            {/* <DropdownMenu /> */}
            {isDropdownVisible5 && (
              <div className="dropdown-menu text-base z-10  w-32">
                <ul>
                  <li>
                    <a href="/8icragee/iset">About ISET</a>
                  </li>
                  <li>
                    <a href="/8icragee/iitg">About IIT Guwahati</a>
                  </li>
                  <li>
                    <a href="/8icragee/iitr">About EQ. Eng. IITR</a>
                  </li>
                </ul>
              </div>
            )}
          </div>
          <div className="">
            <div
              className="menu"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <button>Submissions</button>
              {/* <DropdownMenu /> */}
              {isDropdownVisible && (
                <div className="dropdown-menu text-base z-10 w-32">
                  <ul>
                    <li>
                      <a href="/8icragee/themes">Themes</a>
                    </li>
                    {/* <li onMouseEnter={handleMouseEnter4}>
                      Abstract Submission
                    </li> */}
                    {/* {isSubSubMenuOpen && (
                      <ul
                        className="absolute left-full top-0 mt-0 bg-cyan-600 space-y-2"
                        onMouseLeave={handleMouseLeave4}
                      >
                        <li>
                          <a href="https://event.iitg.ac.in/8icragee/abstract_template.docx">
                            <button className="text-white px-2 py-1 rounded">
                              Download Abstract Template
                            </button>
                          </a>
                        </li>
                        <li>
                          <a href="https://cmt3.research.microsoft.com/8ICRAGEE2024/Submission/Index">
                            <button className="text-white px-2 py-1 rounded">
                              Link for Abstract Submission
                            </button>
                          </a>
                        </li>
                      </ul>
                    )} */}
                    {/* <li onMouseEnter={handleMouseEnter7}>Full Length Paper</li>
                    {isSubSubMenuOpen2 && (
                      <ul
                        className="absolute left-full top-0 mt-0 bg-cyan-600 space-y-2"
                        onMouseLeave={handleMouseLeave7}
                      >
                        <li>
                          <a href="https://event.iitg.ac.in/8icragee/full_length_template.docx">
                            <button className="text-white px-1 py-1 rounded">
                              Download Template for Full Length Paper
                            </button>
                          </a>
                        </li>
                        <li>
                          <a href="https://equinocs.springernature.com/service/8ICRAGEE">
                            <button className="text-white px-2 py-1 rounded">
                              Link for Full Length Paper Submission
                            </button>
                          </a>
                        </li>
                      </ul>
                    )} */}
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="">
            <div
              className="menu"
              onMouseEnter={handleMouseEnter3}
              onMouseLeave={handleMouseLeave3}
            >
              <button>Programme</button>
              {/* <DropdownMenu /> */}
              {isDropdownVisible3 && (
                <div className="dropdown-menu text-base z-10  w-32">
                  <ul>
                    {/* <li>
                      <a href="/8icragee/keydates">Key Dates</a>
                    </li> */}
                    <li onMouseEnter={handleMouseEnter8}>
                      <a>Speakers</a>
                    </li>
                    {isSubSubMenuOpen && (
                      <ul
                        className="absolute left-full top-0 mt-0 bg-cyan-600 space-y-2"
                        onMouseLeave={handleMouseLeave8}
                      >
                        <li>
                          <a href="/8icragee/panelSpeakers">
                            <button className="text-white px-2 py-1 rounded">
                              Plenary Speakers
                            </button>
                          </a>
                        </li>
                        <li>
                          <a href="/8icragee/themeSpeakers">
                            <button className="text-white px-2 py-1 rounded">
                              Theme Speakers
                            </button>
                          </a>
                        </li>
                      </ul>
                    )}
                    <li>
                      <a href="/8icragee/cs">Workshops</a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="w-32">
            <div
              className="menu"
              onMouseEnter={handleMouseEnter2}
              onMouseLeave={handleMouseLeave2}
            >
              <button>Registration</button>
              {/* <DropdownMenu /> */}
              {isDropdownVisible2 && (
                <div className="dropdown-menu text-base z-10 w-32">
                  <ul>
                    <li>
                      <a href="/8icragee/fee">Fee Details</a>
                    </li>
                    <li>
                      <a href="/8icragee/registration">Link for registration</a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="">
            <div
              className="menu"
              onMouseEnter={handleMouseEnter5}
              onMouseLeave={handleMouseLeave5}
            >
              <button>Committee</button>
              {/* <DropdownMenu /> */}
              {isDropdownVisible4 && (
                <div className="dropdown-menu text-base z-10  w-32">
                  <ul>
                    <li>
                      <a href="/8icragee/committee">Organizing Committee</a>
                    </li>
                    <li>
                      <a href="/8icragee/sciCommittee">Scientific Committee</a>
                    </li>
                    <li>
                      <a href="/8icragee/advCommittee">Advisory Committee</a>
                    </li>
                    <li>
                      <a href="/8icragee/inHouseCommittee">
                        In-House Committee
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
          <div className="">
            <a href="/8icragee/sponsors">Sponsorship</a>
          </div>
          <div
            className="menu"
            onMouseEnter={handleMouseEnter9}
            onMouseLeave={handleMouseLeave9}
          >
            <button>Accomodation</button>
            {isDropdownVisible9 && (
              <div className="dropdown-menu text-base z-10  w-32">
                <ul>
                  <li>
                    <a href="/8icragee/hostelAccomodationCharges">
                      Accomodation options nearby IIT Guwahati
                    </a>
                  </li>
                  {/* <li>
                    <a href="/8icragee/hostelAccomodationCharges">
                      Hostel Accomodation Charges
                    </a>
                  </li> */}
                  <li>
                    <a href="https://forms.gle/qjry1RDTK2xzR4nt5">
                      Link for hostel Accomodation
                    </a>
                  </li>
                </ul>
              </div>
            )}
          </div>
          <div className="">
            <a href="/8icragee/contact"> Contact Us</a>
          </div>
          {/* </div> */}
        </nav>
        <button
          onClick={handleShow}
          data-collapse-toggle="navbar-dropdown"
          type="button"
          className="inline-flex items-center m-2 p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="navbar-dropdown"
          aria-expanded="false"
        >
          <span class="sr-only">Open main menu</span>
          <svg
            class="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        {show && (
          <div className="md:hidden">
            <div className="bg-cyan-600 py-4 text-white font-bold text-lg">
              <div className="text-center p-2">
                <a href="/8icragee/">Home</a>
              </div>
              <div className="text-center p-2">
                <button onClick={handleSubmissionsClick}>Submissions</button>
                {isSubmissionsOpen && (
                  <ul className="bg-cyan-700">
                    <li className="p-2">
                      <a href="/8icragee/themes">Themes</a>
                    </li>
                  </ul>
                )}
              </div>
              <div className="text-center">
                <button onClick={handleProgrammeClick} className="p-2">
                  Programme
                </button>
                {isProgrammeOpen && (
                  <ul className="bg-cyan-700">
                    {/* <li className="p-2">
                      <a href="/8icragee/keydates" className="p-2">
                        Key Dates
                      </a>
                    </li> */}
                    <li className="p-2">
                      <a href="/8icragee/panelSpeakers" className="p-2">
                        <button onClick={handleSpeakersClick} className="p-2">
                          Speakers
                        </button>
                      </a>
                    </li>
                    {isSpeakersOpen && (
                      <ul className="bg-cyan-800">
                        <li>
                          <a href="/8icragee/panelSpeakers">
                            <button className="p-2">Plenary Speakers</button>
                          </a>
                        </li>
                        <li>
                          <a href="/8icragee/themeSpeakers">
                            <button className="p-2">Theme Speakers</button>
                          </a>
                        </li>
                      </ul>
                    )}
                    <li className="p-2">
                      <a href="/8icragee/cs" className="p-2">
                        Workshops
                      </a>
                    </li>
                  </ul>
                )}
              </div>
              <div className="text-center">
                <button onClick={handleRegistrationClick} className="p-2">
                  Registration
                </button>
                {isRegistrationOpen && (
                  <ul className="bg-cyan-700">
                    <li className="p-2">
                      <a href="/8icragee/fee" className="p-2">
                        Fee Details
                      </a>
                    </li>
                    <li className="p-2">
                      <a href="/8icragee/registration" className="p-2">
                        Link for registration
                      </a>
                    </li>
                  </ul>
                )}
              </div>
              <div className="text-center p-2">
                <button onClick={handleCommitteeClick} className="p-2">
                  Committee
                </button>
                {isCommitteeOpen && (
                  <ul className="bg-cyan-700">
                    <li className="p-2">
                      <a href="/8icragee/committee" className="p-2">
                        Organizing Committee
                      </a>
                    </li>
                    <li className="p-2">
                      <a href="/8icragee/sciCommittee" className="p-2">
                        Scientific Committee
                      </a>
                    </li>
                    <li className="p-2">
                      <a href="/8icragee/advCommittee" className="p-2">
                        Advisory Committee
                      </a>
                    </li>
                    <li className="p-2">
                      <a href="/8icragee/inHouseCommittee" className="p-2">
                        In-House Committee
                      </a>
                    </li>
                  </ul>
                )}
              </div>
              <div className="text-center p-2">
                <a href="/8icragee/sponsors" className="p-2">
                  Sponsorship
                </a>
              </div>
              <div className="text-center p-2">
                <button onClick={handleAccoClick} className="p-2">
                  Accomodation
                </button>
                {isAccomodationOpen && (
                  <ul className="bg-cyan-700">
                    <li className="p-2">
                      <a
                        href="/8icragee/hostelAccomodationCharges"
                        className="p-2"
                      >
                        Accomodation options nearby IIT Guwahati
                      </a>
                    </li>
                    <li className="p-2">
                      <a
                        href="https://forms.gle/qjry1RDTK2xzR4nt5"
                        className="p-2"
                      >
                        Link for hostel Accomodation
                      </a>
                    </li>
                  </ul>
                )}
              </div>
              <div className="text-center p-2">
                <a href="/8icragee/contact" className="p-2">
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Navbar;
